import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promotion-sidebar',
  templateUrl: './promotion-sidebar.component.html',
  styleUrls: ['./promotion-sidebar.component.scss']
})
export class PromotionSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
